import styled from 'styled-components';
import { Fragment } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { variableFontRegular } from 'styles/theme';
import { LocalizedCurrency } from 'shared/components/LocalizedCurrency';

interface IGridTableHeader {
  display: string;
  dataQa: string;
}

interface IGridTableRow {
  text: string | number;
  subtext?: string;
  dataQa: string;
  type?: string;
}

interface IGridTable {
  className?: string;
  header: IGridTableHeader[];
  rows: Array<IGridTableRow[]>;
}

export const GridTable = ({ className, header, rows }: IGridTable) => {
  const columns = header.length;

  return (
    <GridTable.Table columns={columns} className={className}>
      {header.map(({ display, dataQa }, index) => {
        const indexNum = index + 1;
        return (
          <GridTable.Header data-qa={dataQa} alignRight={indexNum % columns === 0} key={display}>
            {display}
          </GridTable.Header>
        );
      })}
      {rows.map((row) => (
        <Fragment key={uuidv4()}>
          {row.map(({ dataQa, text, subtext, type }, index) => {
            const indexNum = index + 1;
            return (
              <GridTable.Data alignRight={indexNum % columns === 0} data-qa={dataQa} key={uuidv4()}>
                {text && (
                  <GridTable.DataText>
                    {type === 'price' && typeof text === 'number' ? (
                      <LocalizedCurrency price={text} />
                    ) : (
                      text
                    )}
                  </GridTable.DataText>
                )}
                {subtext && <GridTable.DataSubtext>{subtext}</GridTable.DataSubtext>}
              </GridTable.Data>
            );
          })}
        </Fragment>
      ))}
    </GridTable.Table>
  );
};

GridTable.Table = styled.div<{ columns: number }>`
  display: grid;
  grid-template-columns: ${({ columns }) => `repeat(${columns}, 1fr)`};
  column-gap: 16px;
  row-gap: 12px;
  margin-bottom: 16px;
`;

GridTable.Header = styled.div<{ alignRight?: boolean }>`
  ${variableFontRegular({ size: '9px', height: '12px' })};
  text-align: ${({ alignRight }) => alignRight && 'right'};
`;

GridTable.Data = styled.div<{ alignRight?: boolean }>`
  text-align: ${({ alignRight }) => alignRight && 'right'};
`;

GridTable.DataText = styled.div`
  ${variableFontRegular({ size: '11.5px', height: '14px' })};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

GridTable.DataSubtext = styled.div`
  ${variableFontRegular({ size: '9px', height: '12px' })};
`;
